import type { App, DirectiveBinding } from 'vue'
import { useUserStore } from '@/stores/user'

const applyPermission = (element: HTMLElement, binding: DirectiveBinding<string[]>): void => {
  const required = binding.value ?? []
  if (required.length && !useUserStore().hasEveryPermission(required)) element.remove()
}

export const registerPermissionDirective = (app: App): void => {
  app.directive('permission', { mounted: applyPermission })
}
